import maDatePicker from 'v-calendar/lib/components/date-picker.umd'

/**
 * @module
 * @name datePicker
 */
export default {
  name: 'datePicker',
  props: {
    literal: {
      required: true,
      type: String
    },
    errorInput: {
      required: false,
      type: Boolean
    },
    handleChangeInput: {
      required: true,
      type: Function
    },
    futureDates: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  /**
   * @property {Object} dateMask data picker property - the date format of the input value as a mask
   * @property {Object} datePopover data picker property - sets the way the calendar appears
   * @property {String} minDate data picker property - the minimum date it can be selected
   * @property {String} value data picker property - value of the input, not needed as it is passed by the handleChangeInput action by props
   * @property {String} datePickerProps data picker property - holds the props as class and placeholder
   * @property {Object} theme data picker property - holds the sytle related props as the container liht theme class or color of the dot of the calendar
   */
  data: function () {
    return {
      dateMask: {
        input: ['DD/MM/YYYY']
      },
      datePopover: {
        visibility: 'click'
      },
      minDate: null,
      maxDate: null,
      value: '',
      locale: 'fr-FR',
      datePickerProps: {
        class: 'datePicker-input',
        placeholder: 'JJ/MM/AAAA'
      },
      theme: {
        container: {
          light: 'popover-calendar'
        },
        color: 'blue'
      }
    }
  },
  components: {
    maDatePicker
  },

  methods: {
    /**
     * @function
     * @name setMinDate
     * @descrription Sets the minimum date - 20years before the current date
     */
    setMinDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const day = today.getDate()
      if (!this.futureDates) {
        this.minDate = new Date(year - 20, month, day)
        this.maxDate = new Date()
      } else {
        this.minDate = new Date()
        this.maxDate = new Date(year + 20, month, day)
      }
    },

    /**
     * @function
     * @name setLocale
     * @descrription Sets the language
     */
    setLocale() {
      let rawLocale = localStorage.getItem('locale') || 'fr'
      
      const fixes = {
        'es_ES': 'es-ES',
        'fr_FR': 'fr-FR', 
        'en_US': 'en-US',
        'es': 'es-ES',
        'fr': 'fr-FR',
        'en': 'en-US'
      }
      
      const fixedLocale = fixes[rawLocale] || rawLocale.replace('_', '-')
      
      try {
        new Intl.DateTimeFormat(fixedLocale)
        this.locale = fixedLocale
      } catch (error) {
        console.warn('Invalid locale, using fr-FR')
        this.locale = 'fr-FR'
      }
    }
  },

  /**
   * @function
   * @name mounted
   * @descrription Executes the setMinDate and setLocale methods
   */
  mounted() {
    this.setMinDate()
    this.setLocale()
  }
}